import React, { ReactText, ReactChild, createElement, ReactElement } from 'react';
import cn from 'classnames';
import { formatPrice, FormatedPriceType } from 'base/utils/price';
import styles from './index.module.less';

export type ThemePriceType = 'text' | 'theme';

interface ThemePriceProps {
    value: ReactText | ReactText[] | undefined; //价格
    type?: ThemePriceType; //显示类型
    isDel?: boolean; //del标签包裹，market price
    className?: string;
    label?: ReactChild; //跟随价格一起展示的元素
    forceDisplay?: boolean; //value为0时是否强制显示
}

const getPrice = (value: ReactText | ReactText[]): ReactText | [ReactText, ReactText] => {
    let price: ReactText | [ReactText, ReactText];
    if (typeof value === 'number' || typeof value === 'string') {
        price = value;
    } else if (value.length >= 2 && value[0] !== value[1]) {
        price = [value[0], value[1]];
    } else {
        price = Number(value[0]);
    }
    return price;
};

const renderPrice = (formatedPrice: FormatedPriceType, type: ThemePriceType, showSymbol: boolean): ReactChild => {
    const { currencySymbol, integer, decimal, currency } = formatedPrice;
    const currencyBehind = currency === 'EUR';

    if (type === 'theme') {
        return (
            <>
                {!currencyBehind && showSymbol && <em className="symbol mr-1">{currencySymbol}</em>}
                <em className="integer">{integer}</em>
                <em className="decimal">{decimal}</em>
                {currencyBehind && showSymbol && <em className="symbol ml-1">{currencySymbol}</em>}
            </>
        );
    }

    const beforeSymbol = !currencyBehind && showSymbol ? `${currencySymbol} ` : ''
    const behindSymbol = currencyBehind && showSymbol ? ` ${currencySymbol}` : ''
    return `${beforeSymbol}${integer}${decimal}${behindSymbol}`;
};

const ThemePrice: React.FC<ThemePriceProps> = (props) => {
    const {
        type = 'text',
        value = 0,
        className = '',
        isDel = false,
        label,
        forceDisplay = false,
    } = props;

    let dom: ReactElement | null = null;

    if (value || forceDisplay) {
        let child: ReactChild;
        const price = getPrice(value);
        if (typeof price === 'object') {
            const price1 = formatPrice(price[0]);
            const price2 = formatPrice(price[1]);
            child = (
                <>
                    {type === 'theme' ? <em className="symbol">{price1.currencySymbol}</em> : price1.currencySymbol}
                    {renderPrice(price1, type, false)}
                    <em className="separator">-</em>
                    {renderPrice(price2, type, false)}
                </>
            );

        } else {
            child = renderPrice(formatPrice(price), type, true);
        }
        child = createElement(
            (isDel && type === 'text') ? 'del' : 'span',
            {
                className: cn(
                    label ? 'price-num' : 'price',
                    styles.price,
                    { [className]: !label },
                )
            },
            child
        );

        dom = label
            ? (
                <span className={cn('price', className)}>
                        <span className="label">{label}</span>
                    {child}
                </span>
            )
            : child
    }

    return dom;
}

export default ThemePrice;
